import React from "react"
import { Div, Text } from "atomize"
import { motion } from "framer-motion"
import { theme } from "../settings/config"
import ToggleChip from "../atoms/ToggleChip"

// Campi, prezzi e tariffe sono tutti divisi per sport. Invece di impilare
// una sezione apribile per ognuno, si sceglie lo sport qui e sotto si vede
// solo quello: una cosa alla volta, come nel resto dell'app.
function SportSelector({ sportIDs, selected, onSelect, addableSportIDs, onAdd, getSport }) {
	const name = sportID => getSport(sportID)?.sportName ?? sportID

	if (sportIDs.length <= 1 && (addableSportIDs ?? []).length === 0) return null

	return (
		<Div d="flex" overflow="auto" m={{ b: "1rem" }} style={{ gap: "0.5rem" }}>
			{sportIDs.map(sportID => (
				<motion.div key={sportID} whileTap={{ scale: 0.95 }} style={{ flexShrink: 0 }}>
					<Div
						p="0.4rem 1rem"
						rounded="20px"
						cursor="pointer"
						transition
						bg={sportID === selected ? theme.colors.gunmetal_fill : theme.colors.background}
						onClick={() => onSelect(sportID)}>
						<Text
							textSize="body"
							textWeight={sportID === selected ? "bold" : "normal"}
							textColor={
								sportID === selected ? theme.colors.white : theme.colors.text
							}
							style={{ whiteSpace: "nowrap" }}>
							{name(sportID)}
						</Text>
					</Div>
				</motion.div>
			))}

			{(addableSportIDs ?? []).map(sportID => (
				<Div key={sportID} style={{ flexShrink: 0 }}>
					<ToggleChip text={name(sportID)} isSelected={false} onClick={() => onAdd(sportID)} />
				</Div>
			))}
		</Div>
	)
}

export default SportSelector
